module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Getting the Most Out of"), _c('br'), _c('i', [_vm._v("1 & 2 Peter and Jude")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It was a shaky time for Christians in the Roman Empire. In A.D. 68 Emperor Nero saw himself surrounded by political enemies and took the easy way out: suicide. In the next year three emperors, in rapid succession, took his place but couldn’t hold the job. So in A.D. 69 troops proclaimed the military leader Vespasian as emperor—and saw that he stayed there.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Vespasian hated Jews, and he counted Christians among them. Prior to becoming emperor his goal had been to trample Judea and erase it from existence. As emperor he sent his oldest son, Titus, to finish the job. Titus put Jerusalem under siege for three months. Then he tightened the noose. Troops leveled buildings to the ground. The temple became a crumble of stones. Jerusalem fell. Jews (and Christians) became Roman captives.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Aftershocks vibrated throughout the Roman Empire, blending with the general persecution against “atheists” (people who refused to worship Roman gods) that Nero had begun. Christians everywhere suffered. They were driven from their homes, deported to the outer borders of the empire, forbidden to worship openly and, worse yet, splintered by their own internal doctrinal disputes.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is possible that the apostle Paul was martyred under Nero. And Peter was martyred as well—crucified upside down, tradition says, because he felt unworthy to die in the same position as his Lord. It was a dark season for Christians.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("How were they to endure?")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Letters")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Peter and Jude, through God’s inspiration, sensed this coming darkness. If conservative scholars are correct, Peter’s first letter can be "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("dated about A.D. 64, probably written from the city of Rome—which Peter called Babylon in 5:13. Peter’s second letter refers appreciatively in 3:15-16 to Paul’s letters but bears no hint that Paul is dead. On the other hand, Peter seems to anticipate his own death—soon (see "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=2+Peter+1%3A13-14&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("2 Peter 1:13-14")]), _vm._v("). Scholars therefore date this letter in the sixties as well—but closer to the end of the decade. Jude, the half-brother of Jesus Christ, wrote in the same era. In fact, much of the information in Jude is also found in 2 Peter 2. All three letters aim at preparing Christians for hardship.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But these are not bleak letters. Indeed they are full of hope and practical counsel on how to endure. They tell us to balance holy living with correct doctrine, to nurture spiritual growth, to work within existing authority structures and to take care of each other.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These letters do not tell us how to escape suffering but rather to expect it. They show us that in the midst of suffering we can enjoy our fellowship with other believers and look forward to a new heaven and a new earth, a “home of righteousness,” with an end to pain.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These letters, sent with prophetic love to first-century Christians, still live today. They are a compass for our own dark road.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Suggestions for Individual Study")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("1. ")]), _vm._v("As you begin each study, pray that God will speak to you through his Word.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("2. ")]), _vm._v("Read the introduction to the study and respond to the personal reflection question or exercise. This is designed to help you focus on God and on the theme of the study.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("3. ")]), _vm._v("Each study deals with a particular passage—so that you can delve into the author’s meaning in that context. Read and reread the passage to be studied. The questions are written using the language of the New International Version, so you may wish to use that version of the Bible. The New Revised Standard Version is also recommended.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("4. ")]), _vm._v("This is an inductive Bible study, designed to help you discover for yourself what Scripture is saying. The study includes three types of questions. "), _c('i', [_vm._v("Observation ")]), _vm._v("questions ask about the basic facts: who, what, when, where and how. "), _c('i', [_vm._v("Interpretation ")]), _vm._v("questions delve into the meaning of the passage. "), _c('i', [_vm._v("Application ")]), _vm._v("questions help you discover the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("implications of the text for growing in Christ. These three keys unlock the treasures of Scripture.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Write your answers to the questions in the spaces provided or in a personal journal. Writing can bring clarity and deeper understanding of yourself and of God’s Word.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("5. ")]), _vm._v("It might be good to have a Bible dictionary handy. Use it to look up any unfamiliar words, names or places.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("6. ")]), _vm._v("Use the prayer suggestion to guide you in thanking God for what you have learned and to pray about the applications that have come to mind.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("7. ")]), _vm._v("You may want to go on to the suggestion under “Now or Later,” or you may want to use that idea for your next study.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Suggestions for Members of a Group Study")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("1. ")]), _vm._v("Come to the study prepared. Follow the suggestions for individual study mentioned above. You will find that careful preparation will greatly enrich your time spent in group discussion.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("2. ")]), _vm._v("Be willing to participate in the discussion. The leader of your group will not be lecturing. Instead, he or she will be encouraging the members of the group to discuss what they have learned. The leader will be asking the questions that are found in this guide.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("3. ")]), _vm._v("Stick to the topic being discussed. Your answers should be based on the verses which are the focus of the discussion and not on outside authorities such as commentaries or speakers. These studies focus on a particular passage of Scripture. Only rarely should you refer to other portions of the Bible. This allows for everyone to participate in in-depth study on equal ground.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("4. ")]), _vm._v("Be sensitive to the other members of the group. Listen attentively when they describe what they have learned. You may be surprised by their insights! Each question assumes a variety of answers. Many questions do not have “right” answers, particularly questions that aim at meaning or application. Instead the questions push us to explore the passage more thoroughly.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When possible, link what you say to the comments of others. Also, be affirming whenever you can. This will encourage some of the more hesitant members of the group to participate.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("5. ")])]), _vm._v("Be careful not to dominate the discussion. We are sometimes so eager to express our thoughts that we leave too little opportunity for others to respond. By all means participate! But allow others to also.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("6. ")]), _vm._v("Expect God to teach you through the passage being discussed and through the other members of the group. Pray that you will have an enjoyable and profitable time together, but also that as a result of the study you will find ways that you can take action individually and/or as a group.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("7. ")]), _vm._v("Remember that anything said in the group is considered confidential and should not be discussed outside the group unless specific permission is given to do so.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("8. ")]), _vm._v("If you are the group leader, you will find additional suggestions at the back of the guide.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0